import React, { Component } from 'react';
import axios from 'axios';

class Administrator extends Component {
   constructor(props) {
      super(props);

      this.state = {
         people: [],
         loading: false,
         error: null,
         search: '',
         dateFrom: '',
         dateTo: '',
         completadoresFilter: 'none', // none | more_than_one
         expedientesFilter: 'no', // no | yes
         isPayingFilter: '', // '' | 1 | 0 | null
         monthlyStats: [],
         totalPersons: 0,
         personsWithMultipleProviders: 0,
         currentPage: 1,
         lastPage: 1,
         status: 'active', // active | deleted | all
         sortBy: 'created_at',
         sortDir: 'desc', // asc | desc
      };

      this.handleSearchChange = this.handleSearchChange.bind(this);
      this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
      this.fetchPeople = this.fetchPeople.bind(this);
      this.handlePageChange = this.handlePageChange.bind(this);
      this.handleStatusChange = this.handleStatusChange.bind(this);
      this.handleSort = this.handleSort.bind(this);
      this.handleDateFromChange = this.handleDateFromChange.bind(this);
      this.handleDateToChange = this.handleDateToChange.bind(this);
      this.handleCompletadoresFilterChange = this.handleCompletadoresFilterChange.bind(this);
      this.handleExpedientesFilterChange = this.handleExpedientesFilterChange.bind(this);
      this.handleIsPayingFilterChange = this.handleIsPayingFilterChange.bind(this);
      this.handleResetFilters = this.handleResetFilters.bind(this);
      this.handleExport = this.handleExport.bind(this);
   }

   componentDidMount() {
      this.fetchPeople();
   }

   fetchPeople(page = 1) {
      this.setState({ loading: true, error: null });
      console.log('get')
      axios
         .get('/api/administrator/people', {
            params: {
               page,
               search: this.state.search || undefined,
               status: this.state.status || undefined,
               sort_by: this.state.sortBy || undefined,
               sort_dir: this.state.sortDir || undefined,
               date_from: this.state.dateFrom || undefined,
               date_to: this.state.dateTo || undefined,
               completadores_filter: this.state.completadoresFilter || 'none',
               expedientes_filter: this.state.expedientesFilter || 'no',
               is_paying: this.state.isPayingFilter || undefined,
            },
         })
         .then((response) => {
            console.log(response)
            const data = response.data;
            this.setState({
               people: data.data || [],
               currentPage: data.current_page || 1,
               lastPage: data.last_page || 1,
               // "Total de personas" debe mostrar la cantidad de páginas (last_page)
               totalPersons: data.total || 0,
               personsWithMultipleProviders: data.persons_with_multiple_providers ?? 0,
               monthlyStats: data.monthly_stats || [],
               loading: false,
            });
         })
         .catch(() => {
            this.setState({
               loading: false,
               error: 'Ocurrió un error al cargar las personas.',
            });
         });
   }

   handleSearchChange(event) {
      this.setState({ search: event.target.value });
   }

   handleDateFromChange(event) {
      this.setState({ dateFrom: event.target.value });
   }

   handleDateToChange(event) {
      this.setState({ dateTo: event.target.value });
   }

   handleCompletadoresFilterChange(event) {
      this.setState({ completadoresFilter: event.target.value }, () => {
         this.fetchPeople(1);
      });
   }

   handleExpedientesFilterChange(event) {
      this.setState({ expedientesFilter: event.target.value }, () => {
         this.fetchPeople(1);
      });
   }

   handleIsPayingFilterChange(event) {
      this.setState({ isPayingFilter: event.target.value }, () => {
         this.fetchPeople(1);
      });
   }

   handleResetFilters() {
      this.setState({
         search: '',
         dateFrom: '',
         dateTo: '',
         status: 'all',
         completadoresFilter: '',
         expedientesFilter: '',
         isPayingFilter: '',
         sortBy: 'created_at',
         sortDir: 'desc',
      }, () => {
         this.fetchPeople(1);
      });
   }

   handleStatusChange(event) {
      this.setState({ status: event.target.value }, () => {
         this.fetchPeople(1);
      });
   }

   handleSort(column) {
      this.setState((prevState) => {
         let sortDir = 'asc';
         if (prevState.sortBy === column && prevState.sortDir === 'asc') {
            sortDir = 'desc';
         }

         return {
            sortBy: column,
            sortDir,
         };
      }, () => {
         this.fetchPeople(1);
      });
   }

   handleSearchSubmit(event) {
      event.preventDefault();
      this.fetchPeople(1);
   }

   handlePageChange(page) {
      if (page < 1 || page > this.state.lastPage || page === this.state.currentPage) {
         return;
      }

      this.fetchPeople(page);
   }

   handleExport() {
      const params = new URLSearchParams();
      if (this.state.search) params.append('search', this.state.search);
      if (this.state.status) params.append('status', this.state.status);
      if (this.state.dateFrom) params.append('date_from', this.state.dateFrom);
      if (this.state.dateTo) params.append('date_to', this.state.dateTo);
      if (this.state.completadoresFilter) params.append('completadores_filter', this.state.completadoresFilter);
      if (this.state.expedientesFilter) params.append('expedientes_filter', this.state.expedientesFilter);
      if (this.state.isPayingFilter) params.append('is_paying', this.state.isPayingFilter);

      const url = `/api/administrator/people/export${params.toString() ? `?${params.toString()}` : ''}`;
      window.location.href = url;
   }

   render() {
      const { people, loading, error, search, status, sortBy, sortDir, currentPage, lastPage, dateFrom, dateTo, totalPersons, personsWithMultipleProviders, completadoresFilter, expedientesFilter, isPayingFilter, monthlyStats } = this.state;

      return (
         <div className="card card-custom gutter-b">
           
            <div className="mb-3 d-flex flex-wrap align-items-center justify-content-between">
               <div className="d-flex flex-wrap">
                  <div className="card mr-3 mb-3" style={{ minWidth: '220px' }}>
                     <div className="card-body">
                        <h6 className="card-title mb-1">Total de personas</h6>
                        <div className="h4 mb-0">{totalPersons}</div>
                     </div>
                  </div>

                  <div className="card mb-3" style={{ minWidth: '220px' }}>
                     <div className="card-body">
                        <h6 className="card-title mb-1">Personas con &gt; 1 completador</h6>
                        <div className="h4 mb-0">{personsWithMultipleProviders}</div>
                     </div>
                  </div>
               </div>

               <a href="/administrator/logs" className="btn btn-primary mb-3">
                  Logs
               </a>
            </div>

            {/* Resumen mensual según filtros aplicados */}
            {monthlyStats && monthlyStats.length > 0 && (
               <div className="mb-3">
                  <h6 className="mb-1">Personas por mes (según filtros):</h6>
                  <div className="d-flex flex-wrap">
                     {monthlyStats.map((item, index) => {
                        const year = item.year;
                        const month = item.month; // 1-12
                        const total = item.total;

                        const monthNames = [
                           'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                           'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
                        ];

                        const monthLabel = monthNames[(month || 1) - 1] || month;

                        return (
                           <div
                              key={index}
                              className="badge badge-light mr-2 mb-2 p-2"
                              style={{ fontSize: '0.9rem' }}
                           >
                              <strong>{monthLabel} {year}</strong>: {total} empresas
                           </div>
                        );
                     })}
                  </div>
               </div>
            )}
            <form className="form-inline mb-3" onSubmit={this.handleSearchSubmit}>
               <div className="form-group mr-2">
                  <input
                     type="text"
                     className="form-control"
                     placeholder="Buscar por RFC o Razón Social"
                     value={search}
                     onChange={this.handleSearchChange}
                  />
               </div>

               <div className="form-group mr-2">
                  <label className="mr-1 mb-0">Desde</label>
                  <input
                     type="date"
                     className="form-control"
                     value={dateFrom}
                     onChange={this.handleDateFromChange}
                  />
               </div>

               <div className="form-group mr-2">
                  <label className="mr-1 mb-0">Hasta</label>
                  <input
                     type="date"
                     className="form-control"
                     value={dateTo}
                     onChange={this.handleDateToChange}
                  />
               </div>

               <div className="form-group mr-2">
                  <select
                     className="form-control"
                     value={status}
                     onChange={this.handleStatusChange}
                  >
                     <option value="active">Activas</option>
                     <option value="deleted">Eliminadas</option>
                     <option value="all">Todas</option>
                  </select>
               </div>

               <div className="form-group mr-2">
                  <select
                     className="form-control"
                     value={completadoresFilter}
                     onChange={this.handleCompletadoresFilterChange}
                  >
                     <option value="none">Sin completadores</option>
                     <option value="more_than_one">Con más de 1 completador</option>
                  </select>
               </div>

               <div className="form-group mr-2">
                  <select
                     className="form-control"
                     value={expedientesFilter}
                     onChange={this.handleExpedientesFilterChange}
                  >
                     <option value="no">Expedientes solicitados: No</option>
                     <option value="yes">Expedientes solicitados: Sí</option>
                  </select>
               </div>

               <div className="form-group mr-2">
                  <select
                     className="form-control"
                     value={isPayingFilter}
                     onChange={this.handleIsPayingFilterChange}
                  >
                     <option value="">Pago: Todos</option>
                     <option value="1">Pago: Sí paga</option>
                     <option value="0">Pago: No paga</option>
                     <option value="null">Pago: Sin definir</option>
                  </select>
               </div>

               <button type="submit" className="btn btn-primary mr-2">
                  Buscar
               </button>
               <button type="button" className="btn btn-light-primary mr-2" onClick={this.handleResetFilters}>
                  Mostrar todas
               </button>
               <button type="button" className="btn btn-success" onClick={this.handleExport}>
                  Exportar Excel
               </button>
            </form>

            {loading && <div>Cargando...</div>}
            {error && <div className="alert alert-danger">{error}</div>}

            {!loading && !error && (
               <div className="table-responsive">
                  <table className="table table-striped table-bordered w-100">
                     <thead>
                        <tr>
                           <th onClick={() => this.handleSort('rfc')} style={{ cursor: 'pointer' }}>
                              RFC {sortBy === 'rfc' && (sortDir === 'asc' ? '▲' : '▼')}
                           </th>
                           <th onClick={() => this.handleSort('fiscal_name')} style={{ cursor: 'pointer' }}>
                              Razón social {sortBy === 'fiscal_name' && (sortDir === 'asc' ? '▲' : '▼')}
                           </th>
                           <th onClick={() => this.handleSort('name')} style={{ cursor: 'pointer' }}>
                              Nombre {sortBy === 'name' && (sortDir === 'asc' ? '▲' : '▼')}
                           </th>
                           <th onClick={() => this.handleSort('mode')} style={{ cursor: 'pointer' }}>
                              Modo {sortBy === 'mode' && (sortDir === 'asc' ? '▲' : '▼')}
                           </th>
                           <th onClick={() => this.handleSort('created_at')} style={{ cursor: 'pointer' }}>
                              Fecha creación {sortBy === 'created_at' && (sortDir === 'asc' ? '▲' : '▼')}
                           </th>
                           <th onClick={() => this.handleSort('deleted_at')} style={{ cursor: 'pointer' }}>
                              Fecha eliminación {sortBy === 'deleted_at' && (sortDir === 'asc' ? '▲' : '▼')}
                           </th>
                           <th>Cant. completadores</th>
                           <th>Expedientes solicitados</th>
                           <th>dias restantes para eliminar archivos</th>
                           <th>Acciones</th>
                        </tr>
                     </thead>
                     <tbody>
                        {people.length === 0 && (
                           <tr>
                             <td colSpan="10" className="text-center">
                                 No se encontraron resultados.
                              </td>
                           </tr>
                        )}
                        {people.map((person) => {
                           const isDeleted = !!person.deleted_at;
                           const rowClass = isDeleted ? 'table-danger' : '';

                           return (
                           <tr key={person.id} className={rowClass}>
                              <td>{person.rfc}</td>
                              <td>{person.fiscal_name}</td>
                              <td>{person.name}</td>
                              <td>{person.mode || 'completador'}</td>
                              <td>{person.created_at_formatted || ''}</td>
                              <td>{person.deleted_at_formatted || ''}</td>
                              <td>{person.completadores_count ?? 0}</td>
                              <td>{person.expedientes_solicitados ? 'Sí' : 'No'}</td>
                              <td>{person.days_left}</td>
                              <td>
                                 <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() => window.location.href = `/administrator/person/${person.id}`}
                                 >
                                    Administrar
                                 </button>
                              </td>
                           </tr>
                        );})}
                     </tbody>
                  </table>
               </div>
            )}

            {!loading && lastPage > 1 && (
               <nav>
                  <ul className="pagination">
                     <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button
                           type="button"
                           className="page-link"
                           onClick={() => this.handlePageChange(currentPage - 1)}
                        >
                           Anterior
                        </button>
                     </li>
                     <li className="page-item disabled">
                        <span className="page-link">
                           Página {currentPage} de {lastPage}
                        </span>
                     </li>
                     <li className={`page-item ${currentPage === lastPage ? 'disabled' : ''}`}>
                        <button
                           type="button"
                           className="page-link"
                           onClick={() => this.handlePageChange(currentPage + 1)}
                        >
                           Siguiente
                        </button>
                     </li>
                  </ul>
               </nav>
            )}
         </div>
      );
   }
}

export default Administrator;
